<div class="modal-header">
    <div class="text-xl heavy text-primary">Congratulations!</div>
    <button class="btn-close" type="button" data-dismiss="modal" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body">
    <div class="text-lg text-primary mb-2">You set the score to beat!</div>
    <div class="mb-3">Challenge your friends:</div>
    <div class="text-primary italic mb-5">
        Try and beat my score ({{highScore | number: '1.0-0'}}) on Tredder Rally:
        <div class="d-inline-block">https://tredder.com/rally?ref={{refStringEncoded}}</div>
    </div>
    <div class="row">
        <div class="col-6 d-grid">
            <button class="btn rounded-pill btn-primary-gradient text-white fw-500" data-cy="copyToCliboardButton" (click)="copyToClipboard()">
                <div class="d-flex align-items-center">Copy<i-bs class="me-2" name="clipboard"></i-bs></div>
            </button>
        </div>
        <div class="col-6 d-grid">
            <button class="btn rounded-pill btn-primary-gradient text-white fw-500" data-cy="shareButton" (click)="share()" *ngIf="canShare">
                <div class="d-flex align-items-center">Share<i-bs class="me-2" name="box-arrow-up"></i-bs></div>
            </button>
        </div>
    </div>
</div>
